import {
  FormFooter as BaseFormFooter,
  FormFooterCancel,
  FormFooterSubmit,
} from 'components';

export interface FormFooterProps {
  submitLabel?: string;
  editable?: boolean;
  submitDisabled?: boolean;
  submitLoading?: boolean;
  onCancel?: () => void;
}

export const FormFooter = ({
  submitLabel,
  submitDisabled,
  submitLoading,
  editable,
  onCancel,
}: FormFooterProps) => (
  <BaseFormFooter visible={editable}>
    <FormFooterCancel label={submitLabel} onClick={onCancel} />
    <FormFooterSubmit disabled={submitDisabled} loading={submitLoading} />
  </BaseFormFooter>
);
